export default function Introduction() {
  return (
    <section className="py-80 bg-[#FAF8F5]">
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-40 items-center">
          <div className="lg:col-span-5">
            <div className="inline-block border-2 border-gray-800 px-12 py-6 rounded-full mb-16">
              <span className="text-2xl font-medium text-gray-800">Desde 1985</span>
            </div>
            
            <h2 className="font-bold text-gray-900 mb-12 leading-tight" style={{ fontSize: '10rem' }}>
              Creatividad y Calidad
            </h2>
            <h3 className="font-light text-gray-500 mb-20 leading-tight" style={{ fontSize: '10rem' }}>
              en cada detalle
            </h3>

            <p className="text-4xl text-gray-700 leading-relaxed mb-20" style={{ lineHeight: '1.8' }}>
              En Marquetería y Vidriería Hollywood, nos especializamos en el arte de la enmarcación, 
              la pintura al óleo y el trabajo en vidrio. Cada proyecto es tratado con dedicación 
              artesanal, combinando técnicas tradicionales con un enfoque contemporáneo para crear 
              piezas únicas que transforman espacios y preservan momentos importantes.
            </p>

            <a href="#contacto" className="text-3xl text-gray-900 font-medium underline hover:text-[#D4856C] transition-colors cursor-pointer">
              Conoce nuestra historia
            </a>
          </div>

          <div className="lg:col-span-7 relative">
            <div className="relative">
              <div className="absolute top-0 left-0 rounded-3xl overflow-hidden shadow-xl" style={{ width: '640px', height: '640px' }}>
                <img
                  src="https://public.readdy.ai/ai/img_res/ab202688df88ab4f5569f2772c767024.jpg"
                  alt="Marcos de cuadros"
                  className="w-full h-full object-cover object-top"
                />
              </div>

              <div className="absolute rounded-3xl overflow-hidden shadow-2xl" style={{ top: '384px', right: '0', width: '768px', height: '960px' }}>
                <img
                  src="https://readdy.ai/api/search-image?query=Beautiful%20original%20oil%20painting%20artwork%20on%20canvas%20showing%20artistic%20brushwork%20and%20rich%20colors%2C%20professional%20fine%20art%20piece%20with%20textured%20paint%20layers%2C%20classical%20painting%20technique%20with%20vibrant%20pigments%2C%20gallery-quality%20artwork%20displayed%20in%20elegant%20setting%2C%20artistic%20composition%20with%20depth%20and%20detail&width=320&height=420&seq=intro-paintings-1&orientation=portrait"
                  alt="Pinturas al óleo"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            <div className="absolute -top-16 right-0 flex flex-col gap-20">
              <div className="text-right">
                <div className="font-extrabold text-gray-900" style={{ fontSize: '10rem' }}>500+</div>
                <div className="text-3xl text-gray-600 mt-4">Obras enmarcadas</div>
              </div>
              <div className="text-right">
                <div className="font-extrabold text-gray-900" style={{ fontSize: '10rem' }}>15+</div>
                <div className="text-3xl text-gray-600 mt-4">Años de experiencia</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
